// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSymbolsCustomShape_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 6L4 5L0 11.36L3 14L5.5 12L7.5 13L16 7.52L9.88235 2L6 6ZM9.97435 4.77682L6.4153 8.44372L4.72755 7.59984L2.59951 10.9834L3.06124 11.3898L5.24986 9.63886L7.3746 10.7012L12.7205 7.2547L9.97435 4.77682Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.47059 9.84L5.64706 8.4L0 17.04L4.23529 21L7.76471 18.48L10.5882 20.64L24 11.28L14.8235 3L8.47059 9.84ZM14.9474 5.80554L8.90784 12.3081L6.3385 10.9977L2.59378 16.7271L4.40544 18.421L7.80571 15.9933L10.6424 18.1633L20.7925 11.0796L14.9474 5.80554Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2941 13.12L7.52941 11.2L0 22.72L5.64706 28L10.3529 24.64L14.1176 27.52L32 15.04L19.7647 4L11.2941 13.12ZM19.8885 6.80554L11.7314 15.5881L8.22085 13.7977L2.59378 22.4071L5.8172 25.421L10.3939 22.1532L14.1718 25.0433L28.7925 14.8396L19.8885 6.80554Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSymbolsCustomShape is a generated icon component.
 */
let IconSymbolsCustomShape = IconSymbolsCustomShape_1 = class IconSymbolsCustomShape extends IconBaseElement {
    render() {
        return html `${IconSymbolsCustomShape_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSymbolsCustomShape.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconSymbolsCustomShape = IconSymbolsCustomShape_1 = __decorate([
    customElement('zui-icon-symbols-custom-shape')
], IconSymbolsCustomShape);
export { IconSymbolsCustomShape };
